export {DocumentRpcService} from './document.rpc.service'

export interface DocumentType {
  dtid: string;
  name: string;
}

export interface AccountPreset{
  id:string;
  name: string;
  types: DocumentType[];
}

export enum DocumentActions {
  GeneratePreview = "GeneratePreview",
  GetDocumentDownload = "GetDocumentDownload",
  GetDocumentStream = "GetDocumentStream",
  GetDocumentToken = "GetDocumentToken",
  GetDocuments = "GetDocuments",
  GetBatchDocuments = "GetBatchDocuments",
  CreateUpdateDocument = "CreateUpdateDocument",
  RemoveDocument = "RemoveDocument",
  GetDocumentTypes = "GetDocumentTypes",
  DocumentUpload = "DocumentUpload",
  GetASCIMessage = "GetASCIMessage",
  GetExportStream = "GetExportStream",
  RemoveAccountPreset = "RemoveAccountPreset",
  AddAccountPreset = "AddAccountPreset",
  UpdateAccountPreset = "UpdateAccountPreset",
  GetAccountPresets = "GetAccountPresets",
}
